var map = {
	"./cart/index.js": [
		2232,
		763,
		889,
		847
	],
	"./collection-comparison/index.js": [
		29,
		334
	],
	"./content-carousel/index.js": [
		8222,
		532,
		639,
		283
	],
	"./content-full-width/index.js": [
		1877,
		641
	],
	"./customer/addresses/index.js": [
		6745,
		532,
		576
	],
	"./events-section/index.js": [
		799,
		651
	],
	"./example/index.js": [
		4091,
		532,
		484
	],
	"./faq/index.js": [
		130,
		842
	],
	"./footer/index.js": [
		3401,
		532,
		78
	],
	"./full-width-section/index.js": [
		6826,
		715,
		980
	],
	"./gift-guide/index.js": [
		9800,
		763,
		889,
		829,
		305
	],
	"./header/index.js": [
		9155,
		532,
		763,
		639,
		889,
		864
	],
	"./message/index.js": [
		2658,
		152,
		922
	],
	"./mobile-scrolling-nav/index.js": [
		3040,
		201
	],
	"./page/index.js": [
		1949,
		618
	],
	"./primary-hero/index.js": [
		4698,
		886
	],
	"./product-carousel/index.js": [
		8612,
		763,
		639,
		889,
		829,
		770
	],
	"./product-gift-steps/index.js": [
		9045,
		639,
		829,
		807
	],
	"./product-grid/index.js": [
		5733,
		763,
		889,
		829,
		686
	],
	"./product-press-slider/index.js": [
		8498,
		532,
		639,
		610
	],
	"./product/index.js": [
		1290,
		763,
		639,
		220,
		889,
		829,
		627
	],
	"./redirect-modal/index.js": [
		9111,
		4
	],
	"./secondary-hero/index.js": [
		6960,
		715,
		427
	],
	"./shop-collection/index.js": [
		7271,
		763,
		889,
		829,
		557
	],
	"./simple-gallery-slider/index.js": [
		5981,
		436
	],
	"./utils/storefront/index.js": [
		5509,
		469
	],
	"./video-section/index.js": [
		5324,
		715,
		957
	],
	"./visual-categories/index.js": [
		6649,
		362
	],
	"./yotpo-ugc/index.js": [
		3958,
		532,
		33
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6356;
module.exports = webpackAsyncContext;